import type { DateTime } from 'luxon'
import { getLocale } from '../i18n'

const enSuffixes = new Map([
  ['one', 'st'],
  ['two', 'nd'],
  ['few', 'rd'],
  ['other', 'th'],
])

/**
 * Return the ordinal suffix for the day of a DateTime.
 *
 * - English: 1 → "st", 2 → "nd", 3 → "rd", 4 → "th"
 * - Spanish: always "" (ordinal suffixes are not used)
 */
export const daySuffix = (datetime: DateTime): string => {
  const locale = getLocale()
  if (locale === 'es') return ''

  const pr = new Intl.PluralRules('en-US', { type: 'ordinal' })
  const rule = pr.select(datetime.day)
  return enSuffixes.get(rule) ?? 'th'
}
